export default function GoogleDriveIcon({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#0F9D58" d="M8.1 3h5.8l6.9 12h-5.7L8.1 3Z" />
      <path fill="#F4B400" d="m8.1 3 2.8 4.9L5.2 18H0l8.1-15Z" />
      <path fill="#4285F4" d="M5.2 18 8 13.1h10l2.8 4.9H5.2Z" />
    </svg>
  );
}
